import React, { FC } from 'react';
import classNames from 'classnames';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import Page from '../../../layout/Page/Page';
import Card, { CardBody } from '../../../components/bootstrap/Card';
import Logo from '../../../components/Logo';
import useDarkMode from '../../../hooks/useDarkMode';
import Icon from '../../../components/icon/Icon';

const Maintenance: FC = () => {
	const { darkModeStatus } = useDarkMode();

	return (
		<PageWrapper
			isProtected={false}
			title='Maintenance'
			className={classNames({ 'bg-dark': true })}
		>
			<Page className='p-0'>
				<div className='row h-100 align-items-center justify-content-center'>
					<div className='col-xl-4 col-lg-6 col-md-8 shadow-3d-container'>
						<Card className='shadow-3d-dark' data-tour='maintenance-page'>
							<CardBody>
								<div className='text-center my-5'>
									<Logo width={200} />
								</div>

								<div className='text-center mb-4'>
									<div className='display-6 mb-3'>
										<Icon icon='Build' className='text-warning' />
									</div>
									<h3 className='fw-bold mb-2'>Sistem Dalam Pemeliharaan</h3>
									<p className={classNames('mb-0', { 'text-muted': !darkModeStatus, 'text-light': darkModeStatus })}>
										Saat ini sistem legal sedang dalam masa pemeliharaan.
									</p>
									<p className={classNames('mb-0', { 'text-muted': !darkModeStatus, 'text-light': darkModeStatus })}>
										Silakan kembali lagi nanti.
									</p>
								</div>

								<div className='text-center mt-4 pt-3 border-top'>
									<small className={classNames({ 'text-muted': !darkModeStatus, 'text-light': darkModeStatus })}>
										Terima kasih atas kesabaran Anda.
									</small>
								</div>
							</CardBody>
						</Card>
						<div
							className={classNames(
								'text-center text-decoration-none me-3',
								{ 'link-light': true },
							)}>
							Dompet Dhuafa Enterprise System
						</div>
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};

export default Maintenance;
